import SvgPlayIcon from "jsx:../../../Images/Icons/FontAwesome/solid/play.svg";
import { SvgIcon, SxProps } from "@mui/material";

export function PlaySolidIcon(props: SxProps) {
    return (
        <SvgIcon
            component={SvgPlayIcon}
            inheritViewBox
            sx={{
                color: "var(--community-color-primary-text)",
                ...props,
            }}
        />
    );
}
